import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import StarIcon from "@mui/icons-material/Star";
import PeopleIcon from "@mui/icons-material/People";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhyUs from "../../Images/WhyChooseUs.png";

// Styled components for enhanced visuals
const FeatureSection = styled(Box)(({ theme }) => ({
  backgroundColor: "#f8fafc",
  backgroundImage: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
  padding: theme.spacing(8, 0),
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-100px",
    right: "-100px",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(79, 70, 229, 0.1) 100%)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: "-80px",
    left: "-80px",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(236, 72, 153, 0.1) 0%, rgba(219, 39, 119, 0.1) 100%)",
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow:
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  },
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  alignItems: "flex-start",
  transition: "transform 0.2s ease",
  "&:hover": {
    transform: "translateX(8px)",
  },
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: "44px",
  marginTop: "12px",
  marginRight: "10px",
  background: "linear-gradient(135deg, #6366F1 0%, #4F46E5 100%)",
  borderRadius: "50%",
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiSvgIcon-root": {
    color: "white",
    fontSize: "20px",
  },
}));

const FirstFeatures = () => {
  return (
    <FeatureSection>
      {/* <Container maxWidth="lg"> */}
      <Grid container spacing={6} alignItems="center" justifyContent={"center"}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            mb: 3,
            background: "linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)",
            backgroundClip: "text",
            textFillColor: "transparent",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Why customers choose RiTe Account
        </Typography>
      </Grid>
      <Grid
        container
        spacing={3}
        alignItems="flex-start"
        justifyContent={"space-evenly"}
        mt={2}
      >
        <Grid item xs={12} md={6}>
          <List>
            <StyledListItem>
              <StyledListItemIcon>
                <StarIcon />
              </StyledListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Automate GST & invoicing tasks
                  </Typography>
                }
                secondary="Reduce manual data entry and human errors with our intelligent automation system."
                secondaryTypographyProps={{
                  variant: "body1",
                  color: "text.secondary",
                  sx: { lineHeight: 1.6 },
                }}
              />
            </StyledListItem>
            <StyledListItem>
              <StyledListItemIcon>
                <PeopleIcon />
              </StyledListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Multi-user & role control
                  </Typography>
                }
                secondary="Add your accounting team, restrict access by role with our granular permission system."
                secondaryTypographyProps={{
                  variant: "body1",
                  color: "text.secondary",
                  sx: { lineHeight: 1.6 },
                }}
              />
            </StyledListItem>
            <StyledListItem>
              <StyledListItemIcon>
                <CheckCircleIcon />
              </StyledListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Integrated e-Invoice & e-Way
                  </Typography>
                }
                secondary="Compliant e-Invoice / e-Way workflows built-in to ensure regulatory compliance."
                secondaryTypographyProps={{
                  variant: "body1",
                  color: "text.secondary",
                  sx: { lineHeight: 1.6 },
                }}
              />
            </StyledListItem>
          </List>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={WhyUs}
            alt="AccoMate invoice preview"
            sx={{
              width: "400px",
              height: "auto",
              display: "block",
            }}
          />
        </Grid>
      </Grid>
      {/* </Container> */}
    </FeatureSection>
  );
};

export default FirstFeatures;
